module.exports = __webpack_public_path__ + "static/logo_new-year.67d0b049.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo_new-year.svg
// module id = 522
// module chunks = 168707334958949